// @flow

const PERMANENT: 'permanent' = 'permanent';
const TEMPORARY: 'temporary' = 'temporary';

const POLYGON: 'polygon' = 'polygon';
const CIRCLE: 'circle' = 'circle';
const LINE: 'line' = 'line';

export const TYPES = Object.freeze({
    permanent: PERMANENT,
    temporary: TEMPORARY
});

export const SHAPES = Object.freeze({
    polygon: POLYGON,
    circle: CIRCLE,
    line: LINE
});